// src/pages/JobDetails.js
import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ref, get, update, onValue, off, push, set } from "firebase/database";
import { auth, db } from "../utilities/firebaseConfig";
import Bookingnavbar from "../components/Bookingnavbar";
import backicon from "../assets/backicon.svg";
import timeicon from "../assets/ttime.svg";
import calendericon from "../assets/tcalendar.svg";
import locationicon from "../assets/tlocation.svg";
import taskicon from "../assets/taskimgicon.svg";
import moneyicon from "../assets/moneyicon.svg";
import profileimg from "../assets/workerimg.png";
import closemodal from "../assets/closemodal.svg";
import { ref as dbRef } from "firebase/database";
import activeimg from "../assets/activ.svg";
import PostJob from "../components/post_job/PostJob";
import DashboardLayout from "../components/DashboardLayout";
import Loader from "../components/Loader";
import ClickOutsideWrapper from "../components/ClickOutSideWrapper";
import sendimg from "../assets/sendicon.svg";
import useNotification from "../utilities/NotificationServices";

const JobDetails = () => {
  const { notifyNewMessage } = useNotification();
  const navigate = useNavigate();
  const { jobId } = useParams();
  const [job, setJob] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [technician, setTechnician] = useState(null);
  const [activeprofile, setActiveprofile] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);

  const [isPaused, setIsPaused] = useState(false);
  const [pauseTime, setPauseTime] = useState(null);
  const [completeCode, setCompleteCode] = useState("");
  const [tasksum, setTasksum] = useState(false);
  const [showChat, setShowChatModal] = useState(false);
  const [messages, setMessages] = useState([]);
  const [newMsg, setNewMsg] = useState("");

  // State for storing current user's name (fetched from realtime database)
  const [userName, setUserName] = useState("");
  // 🔁 Initial fetch
  useEffect(() => {
    const jobRef = ref(db, `jobs/${jobId}`);
    get(jobRef).then((snapshot) => {
      if (snapshot.exists()) {
        const jobData = snapshot.val();
        setJob(jobData);

        if (jobData.technicianId) {
          const techRef = ref(db, `technicians/${jobData.technicianId}`);
          get(techRef).then((techSnapshot) => {
            if (techSnapshot.exists()) {
              setTechnician(techSnapshot.val());
            }
          });
        }

        if (jobData?.startTime) {
          setStartTime(jobData.startTime || null);
        }

        setIsPaused(jobData.isPaused || false);
        setPauseTime(jobData.pauseTime || null);

        if (jobData.startTime) {
          if (jobData.isPaused && jobData.pauseTime) {
            setElapsedTime(jobData.pauseTime - jobData.startTime);
          } else {
            setElapsedTime(Date.now() - jobData.startTime);
          }
        }
      }
    });
  }, [jobId]);

  // 🧠 Listen to job changes
  useEffect(() => {
    const jobRef = ref(db, `jobs/${jobId}`);

    const unsubscribe = onValue(jobRef, (snapshot) => {
      if (snapshot.exists()) {
        const jobData = snapshot.val();
        setJob(jobData);
        setStartTime(jobData.startTime || null);
        setIsPaused(jobData.isPaused || false);
        setPauseTime(jobData.pauseTime || null);
        console.log("Job updated:", jobData);
      }
    });

    return () => off(jobRef);
  }, [jobId]);

  // 🕒 Stopwatch logic
  useEffect(() => {
    let interval;
    if (startTime && !isPaused) {
      interval = setInterval(() => {
        setElapsedTime(Date.now() - startTime);
      }, 1000);
    } else if (isPaused && startTime && pauseTime) {
      // Set elapsed time manually if paused
      setElapsedTime(pauseTime - startTime);
    }

    return () => clearInterval(interval);
  }, [startTime, isPaused, pauseTime]);

  // Fetch chat messages for this job.
  useEffect(() => {
    const chatRef = ref(db, `chats/${jobId}`);
    onValue(chatRef, (snapshot) => {
      const data = snapshot.val();
      const msgs = data ? Object.values(data) : [];
      setMessages(msgs);
    });
  }, [jobId]);

  // Fetch the current user's name from the realtime database.
  useEffect(() => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      const uid = currentUser.uid;
      const userRef = ref(db, `users/${uid}`);
      get(userRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const userData = snapshot.val();
            setUserName(
              userData.name + " " + userData.lastName + "(client)" || "User"
            );
          } else {
            setUserName("User");
          }
        })
        .catch((error) => {
          console.error("Error fetching user profile:", error);
          setUserName("User");
        });
    } else {
      navigate(`/job/${jobId}`);
    }
  }, [navigate, jobId]);

const sendMessage = async () => {
  if (newMsg.trim() === "") return;
  const currentUser = auth.currentUser;
  if (!currentUser) return;

  const senderName = userName || "User";
  const messageData = {
    sender: currentUser.uid,
    senderName,
    message: newMsg,
    timestamp: Date.now(),
  };

  try {
    // Save message to database
    await push(ref(db, `chats/${jobId}`), messageData);
    
    // Send notification to the other party
    const recipientId = currentUser.uid === job.userId ? job.technicianId : job.userId;
    
    if (recipientId) {
      await notifyNewMessage(
        {
          id: currentUser.uid,
          name: senderName
        },
        recipientId,
        jobId
      );
    }
    
    setNewMsg("");
  } catch (error) {
    console.error("Error sending message:", error);
  }
};
  const formatWhatsAppTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    // Check if the date is today
    const isToday = date.toDateString() === now.toDateString();
    // Check if the date is yesterday
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (isToday) {
      // Show only time if today.
      return date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    } else if (isYesterday) {
      // Show "Yesterday, HH:MM AM/PM"
      return `Yesterday, ${date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
    } else {
      // Otherwise, show full date and time.
      return (
        date.toLocaleDateString(undefined, {
          weekday: "short",
          month: "short",
          day: "numeric",
          year: "numeric",
        }) +
        ", " +
        date.toLocaleTimeString(undefined, {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })
      );
    }
  };

  // 🧮 Format milliseconds to mm:ss
  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (totalSeconds % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const generateCode = () =>
    Math.floor(100000 + Math.random() * 900000).toString();

  const handleGenerateCode = async () => {
    const code = generateCode();
    await update(ref(db, `jobs/${jobId}`), {
      completeCode: code,
      completiontime: Date.now(),
    });
    setCompleteCode(code);
  };

  // 🔐 Generate random 6-digit start code
  const generateStartCode = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  const getTimeFromTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  };

  // 💾 Save start code to Firebase
  const handleSaveStartCode = async () => {
    try {
      const newCode = generateStartCode();
      const jobRef = ref(db, `jobs/${jobId}`);
      await update(jobRef, {
        startCode: newCode,
        startcodeCreatedAt: Date.now(),
      });

      alert(`Start code ${newCode} was created!`);
    } catch (error) {
      console.error("Error saving start code:", error);
      alert("Failed to save start code.");
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }

  const taskCompletelyDone = async () => {
    try {
      await update(dbRef(db, `jobs/${jobId}`), { completeTask: true });
      alert("Task Completed");
      navigate("/client/dashboard");
    } catch (error) {
      console.error("Error Completing the task", error.message);
    }
  };

  const formatPrice = (price) => {
    if (!price) return "";
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const confirmPayment = async (
    jobId,
    technicianId,
    hourlyRate,
    totalTimeInHours
  ) => {
    try {
      // First validate all parameters
      if (!jobId || jobId === "undefined") {
        throw new Error("Invalid job ID");
      }
      if (!technicianId) {
        throw new Error("Technician ID is required");
      }
      if (isNaN(hourlyRate) || isNaN(totalTimeInHours)) {
        throw new Error("Invalid payment parameters");
      }

      // Convert to numbers to ensure proper calculation
      hourlyRate = Number(hourlyRate);
      totalTimeInHours = Number(totalTimeInHours);

      // Update job status
      const jobRef = ref(db, `jobs/${jobId}`);
      await update(jobRef, {
        paymentStatus: "confirmed",
        paymentConfirmedAt: Date.now(),
        completeTask: true,
      });

      // Update technician's wallet
      const walletRef = ref(db, `wallets/${technicianId}`);
      const transactionRef = ref(
        db,
        `wallets/${technicianId}/transactions/${jobId}`
      );

      // Get current balance
      const snapshot = await get(walletRef);
      const currentBalance = snapshot.exists()
        ? Number(snapshot.val().balance) || 0
        : 0;

      // Calculate amount
      const amount = hourlyRate * totalTimeInHours;

      // Validate amount is a valid number
      if (isNaN(amount)) {
        throw new Error("Invalid payment amount calculation");
      }

      // Update wallet
      await set(walletRef, {
        balance: currentBalance + amount,
        lastUpdated: Date.now(),
      });

      // Add transaction record
      await set(transactionRef, {
        amount: amount,
        jobId: jobId,
        technicianId: technicianId,
        timestamp: Date.now(),
        status: "completed",
        hourlyRate: hourlyRate,
        hoursWorked: totalTimeInHours,
      });

      setTasksum(false);
      alert("Payment confirmed and wallet updated successfully!");
    } catch (error) {
      console.error("Error confirming payment:", error);
      alert(`Failed to confirm payment: ${error.message}`);
    }
  };

  if (!job) return <Loader />;

  return (
    <>
      <PostJob isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      <DashboardLayout>
        <div className='theclientdsh'>
          <button
            className='tdtback'
            onClick={() => navigate("/client/dashboard")}
          >
            {/* <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='48'
              height='48'
              fill='currentColor'
            >
              <path d='M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z'></path>
            </svg> */}
            Back to Dashboard
          </button>
          <div className='skhs'>
            <h1 className='jobtilsasd'>{job.jobtitle}</h1>

            <div className='skhsright'>
              <button
                className='skrschat'
                onClick={() => setShowChatModal(true)}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  height='18'
                  width='18'
                  fill='#fff'
                >
                  <path d='M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242Z'></path>
                </svg>
              </button>
            </div>
          </div>
          <div className='thespacee'></div>
          <div className='jsdeetsep'>
            <div className='jsdeetsepleft'>
              <div className='jdetailsstatus'>
                <div className={`jdboxcircle ${job.status}bx`}></div>
                <p className={`jdboxtext ${job.status}`}>{job.status}</p>
              </div>
              <div className='thespacee'></div>
              <p className='jdetailscnt'>Task info</p>
              <div className='thespace'></div>
              <div className='jdetailsitems'>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img
                      src={calendericon}
                      alt=''
                      className='jdtsitemlefticon'
                    />
                    <p className='jdtsitempar'>Date</p>
                  </div>
                  <div className='jdtsitemright'>
                    <p className='jdtsitemapars'>{formatDate(job.date)}</p>
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img
                      src={locationicon}
                      alt=''
                      className='jdtsitemlefticon'
                    />
                    <p className='jdtsitempar'>Location</p>
                  </div>
                  <div className='jdtsitemright'>
                    <p className='jdtsitemapars'>{job.address}</p>
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img src={timeicon} alt='' className='jdtsitemlefticon' />
                    <p className='jdtsitempar'>Projected time</p>
                  </div>
                  <div className='jdtsitemright'>
                    {job.timeOfDay === "morning" && (
                      <p className='jdtsitemapars'>
                        {job.timeOfDay} <span>Before 10am</span>
                      </p>
                    )}
                    {job.timeOfDay === "midday" && (
                      <p className='jdtsitemapars'>
                        {job.timeOfDay} <span>10am - 2pm</span>
                      </p>
                    )}
                    {job.timeOfDay === "afternoon" && (
                      <p className='jdtsitemapars'>
                        {job.timeOfDay} <span>2pm - 6pm</span>
                      </p>
                    )}
                    {job.timeOfDay === "evening" && (
                      <p className='jdtsitemapars'>
                        {job.timeOfDay} <span>After 6pm</span>
                      </p>
                    )}
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img src={moneyicon} alt='' className='jdtsitemlefticon' />
                    <p className='jdtsitempar'>Price breakdown</p>
                  </div>
                  <div className='jdtsitemright'>
                    <div className='jdtsitemrightitem'>
                      <p className='jtsitpal'>Hourly rate</p>
                      <p className='jtsitpar'>
                        ₦{formatPrice(job.hourlyRate)}/hr
                      </p>
                    </div>
                    <div className='jdtsitemrightitem'>
                      <p className='jtsitpal'>Trust/support fee</p>
                      <p className='jtsitpar'>
                        ₦{formatPrice(job.trustSupportFee)}
                      </p>
                    </div>
                    <div className='jdtsitemrightitem'>
                      <p className='jtsitpal'>Total fee</p>
                      <p className='jtsitpar'>₦{formatPrice(job.totalFee)}</p>
                    </div>
                  </div>
                </div>
                <div className='thespace'></div>
                <div className='dividar'></div>
                <div className='thespace'></div>
                <div className='jdtsitem'>
                  <div className='jdtsitemleft'>
                    <img src={taskicon} alt='' className='jdtsitemlefticon' />
                    <p className='jdtsitempar'>Task details/notes</p>
                  </div>
                  <div className='jdtsitemright'>
                    <div className='jdtsitemrightparcnt'>
                      <p className='jdtsitemaparss'>{job.jobdescription}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='thespacee'></div>

              <div className='thespace'></div>

              <div className='thespacee'></div>
            </div>
            <div className='jsdeetsepright'>
              <div className='jdtechas'>
                {" "}
                {job.technicianId === "" ? (
                  <p className='jdetailstech'>No Technician assigned</p>
                ) : (
                  <p className='jdetailstech'>Technician assigned</p>
                )}
                <div className='thespace'></div>
                {job.technicianId && (
                  <div className='jdtechasleft'>
                    <img
                      src={technician?.profileUrl}
                      alt=''
                      className='jdtechimg'
                    />
                    <div className='jdtechpro'>
                      <h1 className='jdtechproname'>
                        {technician?.name} {technician?.lastName}
                      </h1>
                      <div
                        className={
                          technician?.rating > 3.5
                            ? "wlitoprgreen"
                            : "wlitopryellow"
                        }
                      >
                        <svg
                          width='12'
                          height='12'
                          viewBox='0 0 15 15'
                          fill='#fff'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                            fill='#fff'
                          ></path>
                        </svg>
                        <p className='ratingnum'>{technician?.rating}</p>
                      </div>
                      <p className='jdtechgreat'>{technician?.level}</p>
                    </div>
                  </div>
                )}
                <div className='thespace'></div>
                <div className='jdtechasright'>
                  {!job.technicianId && (
                    <button
                      className='jdtechviewpro'
                      onClick={() => navigate(`/select-technician/${jobId}`)}
                    >
                      Assign a Technician
                    </button>
                  )}
                  {job.technicianId && (
                    <button
                      className='jdtechviewpro'
                      onClick={() => setActiveprofile(true)}
                    >
                      View technician profile
                    </button>
                  )}
                  {job.status === "reject" && job.technicianId !== "" && (
                    <button
                      onClick={() => navigate(`/select-technician/${jobId}`)}
                      className='jdtechviewpro'
                    >
                      Replace technician
                    </button>
                  )}
                </div>
              </div>
              <div className='thespace'></div>
              <div className='dividar'></div>
              <div className='thespace'></div>
              <div className='thewidepagerighttp'>
                <img src={activeimg} alt='' />
                <p className='twprtptitle'>Activity information</p>
              </div>
              <div className='thespace'></div>
              {!startTime && (
                <div className='thewidepagetimestart'>
                  <div className='thesialse'>
                    <p className='thewidgptitle'>
                      Share start code with technician
                    </p>
                    <p className='thwispte'>{job.startCode}</p>
                  </div>

                  <div className='thewidepas'>
                    {!job.startCode && (
                      <button
                        className='thewisptebtn'
                        onClick={handleSaveStartCode}
                      >
                        Generate start code
                      </button>
                    )}
                  </div>
                </div>
              )}
              <div className=''>
                {job.status === "completed" ? (
                  <div className='thewidepagetimestartt'>
                    <div className='thesialse'>
                      <p className='thewidgptitle'>Total Completion task</p>
                      <p className='thwispte'>{job.totalTimeInHours} Hours</p>
                    </div>
                    <div className='thespace'></div>
                    <div className='thewidepas'>
                      <button
                        className='thewisptebtn'
                        onClick={() => setTasksum(true)}
                      >
                        Check Out
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className='thesialse'>
                    <p className='thewidgptitle'>Task current time</p>
                    <div className=''></div>
                    {startTime ? (
                      <>
                        <p className='thwispte'>{formatTime(elapsedTime)} </p>
                        <div className='thespace'></div>
                        <p>Status: {isPaused ? "Paused" : "in progress"}</p>
                      </>
                    ) : (
                      <p className='thwispte'>0:00</p>
                    )}
                  </div>
                )}

                {/* {!startTime  && <div className='thewidepas'>
              <button className='thewisptebtn'>Start task</button>
            </div>} */}
              </div>
              {/* <p style={{ color: "green" }}>
              Task completed successfully. Total time: {job.totalTimeInHours}{" "}
              hours
            </p> */}
              <div className='thespace'></div>
              {startTime && (
                <div className=''>
                  {!job.completedAt && (
                    <div className='thesialse'>
                      <p className='thewidgptitle'>
                        Share completion code with technician
                      </p>
                      <p className='thwispte'>{job.completeCode}</p>
                    </div>
                  )}

                  <div className='thewidepas'>
                    {!job.completeCode && (
                      <button
                        className='thewisptebtn'
                        onClick={handleGenerateCode}
                      >
                        Generate completion code
                      </button>
                    )}
                  </div>
                </div>
              )}
              {/* {(job.status !== "completed" || job.status !== "pending") && (
                <button
                  className='jdtechopenchat'
                  onClick={() => navigate(`/client/chat/${jobId}`)}
                >
                  Open chat
                </button>
              )} */}
              <div className='thespacee'></div>
            </div>
          </div>
        </div>
        {showChat && (
          <>
            <div className='chatoverlay'></div>
            <div className='bookingpagechatcnt'>
              <div className='aks'>
                <button
                  className='tdtbackk'
                  onClick={() => setShowChatModal(false)}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    width='24'
                    height='24'
                    fill='currentColor'
                  >
                    <path d='M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z'></path>
                  </svg>
                  Back
                </button>
              </div>

              <div className='chatcnt'>
                {messages.map((msg, index) => {
                  const isCurrentUser = msg.sender === auth.currentUser.uid;
                  return (
                    <div
                      key={index}
                      className={
                        isCurrentUser ? "thecurrentuser" : "notthecurrentuser"
                      }
                    >
                      <div
                        className={
                          isCurrentUser ? "thetapisncnt" : "notthetapisncnt"
                        }
                      >
                        <div
                          className={
                            isCurrentUser ? "thetapins" : "notthetapins"
                          }
                        >
                          <p className='thesendername'>{msg.senderName}</p>
                          <p className='thesendertime'>
                            {formatWhatsAppTimestamp(msg.timestamp)}
                          </p>
                        </div>

                        <div
                          className={
                            isCurrentUser
                              ? "thecurrentuserbg"
                              : "notthecurrentuserbg"
                          }
                        >
                          <p>{msg.message}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className='thespasl'>
                <div className='thetypemsg'>
                  <input
                    type='text'
                    value={newMsg}
                    placeholder='Type a message..'
                    onChange={(e) => setNewMsg(e.target.value)}
                  />
                  <button className='imgbtn' onClick={sendMessage}>
                    <img src={sendimg} alt='' srcset='' />
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {tasksum && (
          <>
            <div className='summodall'></div>
            <div className='sumbodyy'>
              <div className='sumbodycnt'>
                <div className='sumtop'>
                  <button
                    className='profile-close'
                    onClick={() => setTasksum(false)}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 24 24'
                      width='32'
                      height='32'
                      fill='#fff'
                    >
                      <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
                    </svg>
                  </button>
                </div>
                <div className='thespace'></div>
                <h1 className='sumttitle'>Task Summary</h1>
                <div className='thespacee'></div>
                <p className='profidestitle'>Task title</p>
                <div className='thespace'></div>
                <p className='proffdes'>{job.jobtitle}</p>
                <div className='thespacee'></div>
                <p className='profidestitle'>Your task details</p>

                <div className='thespace'></div>
                <p className='proff'>{job.jobdescription}</p>
                <div className='thespacee'></div>
                <div className='profitems'>
                  <img src={timeicon} alt='' className='pritemimg' />
                  {job.timeOfDay === "morning" && (
                    <p>
                      {job.timeOfDay} <span>Before 10am</span>
                    </p>
                  )}
                  {job.timeOfDay === "midday" && (
                    <p>
                      {job.timeOfDay} <span>10am - 2pm</span>
                    </p>
                  )}
                  {job.timeOfDay === "afternoon" && (
                    <p>
                      {job.timeOfDay} <span>2pm - 6pm</span>
                    </p>
                  )}
                  {job.timeOfDay === "evening" && (
                    <p>
                      {job.timeOfDay} <span>After 6pm</span>
                    </p>
                  )}
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={timeicon} alt='' className='pritemimg' />
                  <p>
                    Start Time:{" "}
                    <span>{getTimeFromTimestamp(job.startTime)}</span>
                  </p>
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={timeicon} alt='' className='pritemimg' />
                  <p>
                    Finished Time:{" "}
                    <span>{getTimeFromTimestamp(job.pauseTime)}</span>
                  </p>
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={calendericon} alt='' className='pritemimg' />
                  <p>{formatDate(job.date)}</p>
                </div>
                <div className='thespace'></div>
                <div className='profitems'>
                  <img src={locationicon} alt='' className='pritemimg' />
                  <p>{job.address}</p>
                </div>
                <div className='thespacee'></div>
                <div className='thespace'></div>
                <div className='divider'></div>
                <div className='thespace'></div>
                <p className='profidestitle'>Price Details</p>
                <div className='thespace'></div>
                <div className='theprdet'>
                  <div className='prodestri'>
                    <p className='prodeslef'>Total hours worked</p>
                    <p className='prodesright'>{job.totalTimeInHours}Hours</p>
                  </div>
                  <div className='prodestri'>
                    <p className='prodeslef'>Hourly rate</p>
                    <p className='prodesright'>
                      ₦{formatPrice(job.hourlyRate)}/hr
                    </p>
                  </div>
                  <div className='prodestri'>
                    <p className='prodeslef'>Trust/support fee</p>
                    <p className='prodesright'> ₦8,000</p>
                  </div>
                  <div className='prodestri'>
                    <p className='prodeslef'>Total fee</p>
                    <p className='prodesright'>
                      ₦
                      {formatPrice(
                        job.hourlyRate * job.totalTimeInHours +
                          job.trustSupportFee
                      )}
                    </p>
                  </div>
                </div>
                <div className='thespacee'></div>
                {!job.completeTask && (
                  <div className='thebottomfetchh'>
                    <div className='thespace'></div>
                    <div className='selettetechbkprr'>
                      <button
                        className='selbkprr'
                        onClick={() => {
                          if (!jobId || jobId === "undefined") {
                            alert("Invalid job ID");
                            return;
                          }
                          confirmPayment(
                            jobId,
                            job.technicianId,
                            job.hourlyRate,
                            job.totalTimeInHours
                          );
                        }}
                      >
                        Confirm Task Completion
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </DashboardLayout>
    </>
  );
};

export default JobDetails;
